import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CloseIcon from 'mdi-react/CloseIcon';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import { partial } from '../../../../util/translation/translation';
import InfoBox from '../../../../shared/components/custom/InfoBox';
import { formatDayTime } from '../seriesUtils';

// What a save did to the occurrences, and the ones it couldn't remove: they
// no longer fit the schedule but people have booked them, so the admin has
// to cancel them by hand
const SeriesUpdateResult = ({ result, occurrences, onDismiss }) => {
  const p = partial('EventSeries');
  const kept = result.keptWithBookings || [];
  const occurrenceById = (id) =>
    occurrences.find((occurrence) => occurrence.id === id);

  return (
    <div className="series-result">
      <InfoBox className="mb-2">
        <div className="d-flex justify-content-between align-items-start">
          <span>
            {p('updateSummary', {
              updated: result.updated || 0,
              created: result.created || 0,
              removed: result.removed || 0,
            })}
          </span>
          <button
            type="button"
            className="series-chip__remove"
            aria-label={p('dismiss')}
            onClick={onDismiss}
          >
            <CloseIcon size={16} />
          </button>
        </div>
      </InfoBox>
      {kept.length > 0 && (
        <div className="alert alert-warning series-result__kept">
          <AlertOutlineIcon size={18} className="mr-2" />
          <div>
            <strong className="d-block mb-1">
              {p('keptWithBookingsTitle', { count: kept.length })}
            </strong>
            <span className="d-block mb-2">{p('keptWithBookingsText')}</span>
            <ul className="mb-0 pl-3">
              {kept.map((id) => {
                const occurrence = occurrenceById(id);
                return (
                  <li key={id}>
                    <Link to={`/events/edit/${id}?tab=3`}>
                      {occurrence
                        ? formatDayTime(occurrence.startDate)
                        : p('openOccurrence')}
                    </Link>
                    {occurrence &&
                      ` · ${p('bookedCount', {
                        count: occurrence.bookedSeats || 0,
                      })}`}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

SeriesUpdateResult.propTypes = {
  result: PropTypes.shape({
    updated: PropTypes.number,
    created: PropTypes.number,
    removed: PropTypes.number,
    keptWithBookings: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  occurrences: PropTypes.arrayOf(PropTypes.shape({})),
  onDismiss: PropTypes.func.isRequired,
};

SeriesUpdateResult.defaultProps = {
  occurrences: [],
};

export default SeriesUpdateResult;
